export const getScoreStyle = (score, lowScore, highScore, themeCss) => {
    if (score < 0) {
        return themeCss.noScore;
    }
    if (themeCss.lowScore && score < lowScore) {
        return themeCss.lowScore;
    }
    if (themeCss.midScore && score < highScore) {
        return themeCss.midScore;
    }
    if (themeCss.highScore && score >= highScore) {
        return themeCss.highScore;
    }
    return '';
};
